<template>
  <div class="popup-outer">
    <div class="popup-inner">
      <div class="popup-content">
        <div class="movie-tutorial">
          <div class="title-area">
            <p class="title">정기 결제 회원이라면<br />wavvie 영화를 무제한으로<br />볼 수 있어요!</p>
          </div>
          <div class="content-area">
            <div class="text-area">
              <p>wavvie 영화, 한 눈에 알아보는 Tip</p>
              <p>영화 포스터의 뱃지를 확인하세요!</p>
            </div>
            <div class="image-area">
              <img src="../../assets/images/img-movietag.png" alt="영화 포스터 뱃지 리스트 이미지">
            </div>
            <ul class="tag-list">
              <li>
                <span class="tag-nothing">태그없음</span>
                <span>뱃지가 없다면&quest; wavvie 영화&excl;</span>
              </li>
              <li>
                <span class="tag-playy">PLAYY</span>
                <span>PLAYY 이용권을 구매하면 시청할 수 있어요.</span>
              </li>
              <li>
                <span class="tag-won">개별구매</span>
                <span>별도 구매가 필요해요.</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="notice-area">
          <p>wavvie 영화 상세화면에 &lsquo;개별구매&rsquo; 또는 &lsquo;PLAYY&rsquo;가 있어도 놀라지 마세요. wavvie라면 재생 버튼을 눌러 시청할 수 있어요.</p>
        </div>
      </div>
      <div class="popup-button-close">
        <a href="#" @click.prevent="close()">
          <img src="../../assets/images/btn-popup-close.png" alt="btn-close">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/common/util/utils'
import { URL_COOKIE_DOMAIN } from '@/common/constant'
export default {
  name: 'WavviePopup',
  data () {
    return {
      isShowPopup: false
    }
  },
  props: {
    closeFn: {
      type: Function
    }
  },
  methods: {
    close () {
      let expires = new Date()
      expires.setDate(expires.getDate() + 365)
      utils.cookies.setItem('wavvie-popup', '1', expires.toUTCString(), URL_COOKIE_DOMAIN, '/')
      this.$router.push({ name: 'movie' })
    }
  }
}
</script>
<style lang="css" src="@/assets/new-css/base.css"></style>
<style scoped>
  .popup-outer img{
    width: 100%;
  }
  .popup-content{
    display: flex;
    flex-direction: column;
    justify-content: start;
    text-align: center;
  }
  .movie-tutorial{
    padding: 62px 10px;
  }
  .movie-tutorial p{
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
  }
  .movie-tutorial .title{
    font-size: 20px;
    line-height: 29px;
    color: #fff;
  }
  .movie-tutorial .text-area{
    padding: 28px 0 24px;
  }
  .movie-tutorial .text-area p:first-child{
    color: #3887ff;
  }
  .movie-tutorial .text-area p + p{
    margin-top: 4px;
  }
  .movie-tutorial .tag-list{
    padding: 28px 10px 0;
    font-size: 0;
    text-align: left;
  }
  .movie-tutorial .tag-list li + li{
    margin-top: 8px;
  }
  .movie-tutorial span[class^="tag-"]{
    display: inline-block;
    width: 50px;
    height: 20px;
    background-color: rgba(0, 0, 0, 0.8);
    font-size: 10px;
    line-height: 18px;
    font-weight: 700;
    text-align: center;
    vertical-align: middle;
  }
  .tag-nothing{
    border: 1px #7d7d7d dashed;
    text-indent: -99999px;
  }
  .tag-playy{
    border: 1px #39b766 solid;
    color: #39b766;
  }
  .tag-won{
    border: 1px #ef299a solid;
    color: #ef299a;
  }
  .movie-tutorial span[class^="tag-"] + span{
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
    line-height: 20px;
    color: #fff;
    vertical-align: middle;
  }
  .notice-area{
    padding: 20px;
    background-color: #101010;
  }
  .notice-area p{
    position: relative;
    padding-left: 6px;
    font-size: 12px;
    line-height: 18px;
    color: #7e7e7e;
    text-align: left;
  }
  .notice-area p::before{
    content: '';
    display: inline-block;
    position: absolute;
    top: 10px;
    left: 0;
    width: 1px;
    height: 1px;
    border: 1px #7e7e7e solid;
    border-radius: 50%;
  }
  .popup-button-close{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
    width: 24px;
    height: 24px;
  }
  .popup-button-close a{
    display: block;
    font-size: 0;
  }

  @media screen and (max-width: 360px){
    .movie-tutorial span[class^="tag-"] + span{
      font-size: 12px;
    }
  }
</style>
